// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-container {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: #f9fafc;
  color: #1b1f3b;
}
.payment-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 9%;
 background: linear-gradient(135deg, #effdfc, #e3edf3 );

  flex-wrap: wrap; /* allows stacking on small screens */
}

.payment-content {
  flex: 1 1;
  min-width: 300px;
}

.payment-image {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: 300px;
}

.payment-image img {
  max-width: 100%;
  /* height: 400px; */
  border-radius: 16px;
  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1); */
}
.zoom-in-image {
  max-width: 100%;
  height: auto;
  border-radius: 16px;
  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1); */

  /* Zoom-in on load */
  transform: scale(0.8);
  opacity: 0;
  animation: zoomIn 1s ease-out forwards;

  /* Optional: slight hover scale */
  transition: transform 0.3s ease;
}

.zoom-in-image:hover {
  transform: scale(1.05);
}

/* Keyframes */
@keyframes zoomIn {
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.slide-in-left {
  opacity: 0;
  transform: translateX(-50px);
  animation: slideLeftFadeIn 1s ease-out forwards;
}

@keyframes slideLeftFadeIn {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}


/* Responsive - stack on mobile */
@media (max-width: 992px) {
  .payment-section {
    flex-direction: column;
    text-align: center;
  }

  .payment-image {
    justify-content: center;
    margin-top: 30px;
  }
}


.payment-content h2 {
  font-size: 40px;
  line-height: 1.3;
  margin-bottom: 20px;
  color: #1b1f3b;
}

.highlight-green {
  color: #00b884;
}

.payment-content p {
  font-size: 18px;
  color: #555;
  margin-bottom: 24px;
  max-width: 500px;
}

.payment-buttons {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.btn-explore,
.btn-start {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  font-size: 14px;
}

.btn-explore {
  background-color: #0b84ff;
  color: #fff;
}

.btn-start {
  background-color: #fff;
  color: #00b884;
  border: 2px solid #00b884;
}

.payment-features {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  font-size: 16px;
  margin-top: 16px;
}

.check-icon {
  color: #00b884;
  font-size: 18px;
}

.payment-card {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  min-width: 500px;
}

.payment-card-balance {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 24px;
  min-width: 320px;
  width: 100%;
  max-width: 400px;
}

.balance-header {
  background: linear-gradient(135deg, #0b84ff, #00b884);
  border-radius: 16px;
  padding: 20px;
  color: #fff;
}

.balance-header p {
  font-size: 18px;
  margin: 0;
}

.balance-header h2 {
  font-size: 32px;
  margin: 8px 0;
}

.balance-header span {
  font-size: 12px;
  color: #e0f7fa;
}

.balance-transactions {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.transaction {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f9fbfd;
  border-radius: 12px;
  padding: 12px 16px;
}

.transaction-icon {
  font-size: 20px;
  margin-right: 12px;
}

.transaction-details {
  flex-grow: 1;
}

.transaction-label {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #1b1f3b;
}

.transaction-time {
  margin: 0;
  font-size: 12px;
  color: #555;
}

.transaction-amount {
  font-size: 14px;
  font-weight: 700;
}

.transaction-amount.income {
  color: #00b884;
}

.transaction-icon.yellow {
  color: #fbbf24;
}

.transaction-icon.purple {
  color: #5a55e4;
}

/* ---------- Responsive Screens ---------- */

@media (max-width: 992px) {
  .payment-section {
    flex-direction: column;
    text-align: center;
    padding: 40px 5%;
  }

  .payment-content {
    text-align: center;
  }

  .payment-card {
    justify-content: center;
    margin-top: 40px;
    min-width: unset;
    width: 100%;
  }

  .payment-card-balance {
    max-width: 90%;
  }

  .payment-buttons {
    justify-content: center;
  }

  .payment-features {
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .payment-content h2 {
    font-size: 32px;
  }

  .payment-content p {
    font-size: 16px;
  }

  .btn-explore,
  .btn-start {
    width: 100%;
    text-align: center;
  }

  .payment-buttons {
    flex-direction: column;
    gap: 12px;
  }

  .payment-card-balance {
    padding: 16px;
  }

  .transaction {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .transaction-amount {
    align-self: flex-end;
  }
}

.offerings {
  text-align: center;
  padding: 70px 10%;
  background-color: #fff;
}

.offerings-heading {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #1b1f3b;
}

.underline {
  width: 50px;
  height: 3px;
  background-color: #00b884;
  margin: 0 auto;
  margin-top: 8px;
}

.offerings-grid {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
  margin-top: 40px;
}

.offering-card {
  background: #f9fbfd;
  border-radius: 16px;
  padding: 30px;
  max-width: 400px;
  text-align: left;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s;
}

.offering-card:hover {
  transform: translateY(-5px);
}

.icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

}

.icon {
  color: #fff;  /* White color for the icon */
  font-size: 24px;
}


.offering-card h3 {
  margin-bottom: 12px;
  color: #1b1f3b;
  font-size: 20px;
}

.offering-card p {
  color: #555;
  font-size: 15px;
  margin-bottom: 20px;
  line-height: 1.6;
}

.learn-more-btn {
  font-weight: 500;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid;
  padding: 6px 12px;
  border-radius: 6px;
  text-decoration: none;
  transition: background-color 0.3s, color 0.3s;
}

.learn-more-btn.green {
  color: #00b884;
  border-color: #00b884;
}

.learn-more-btn.green:hover {
  background-color: #00b884;
  color: #fff;
}

.learn-more-btn.purple {
  color: #5a55e4;
  border-color: #5a55e4;
}

.learn-more-btn.purple:hover {
  background-color: #5a55e4;
  color: #fff;
}

.arrow {
  font-size: 16px;
}
.offering-card, .feature-card, .transform-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  flex: 1 1 250px;
  /* box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08); */
  text-align: center;
  transition: transform 0.3s;
}

.offering-card:hover, .feature-card:hover, .transform-card:hover {
  transform: translateY(-5px);
}
.offering-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  flex: 1 1 250px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  text-align: left;  /* Align content to left */
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align items to the start */
  gap: 10px;
  transition: transform 0.3s;
}

.offering-card svg {
  font-size: 36px;
  color: #0b84ff;
}

.offering-card h3 {
  margin: 0;
  font-size: 20px;
  color: #1b1f3b;
}

.offering-card p {
  font-size: 16px;
  color: #555;
  line-height: 1.6;
}

.offering-card h3, .feature-card, .transform-card h3 {
  margin-top: 12px;
  margin-bottom: 8px;
}


/* Stats Section New Design */
.stats-container {
  background: linear-gradient(135deg, #ebf2f9, #eafff8);
  padding: 60px 10%;
}

.stats-grid {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
}

.stat-item {
    /* background: linear-gradient(135deg, #f5faff, #f9fbfd); */
  /* border-radius: 16px; */
  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); */
  /* padding: 30px 20px; */
  width: 220px;
  text-align: center;
  /* transition: transform 0.3s; */
}

.stat-item:hover {
  transform: translateY(-5px);
}

.icon-wrapper {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.stat-icon {
  color: #fff;
  font-size: 28px;
}

.stat-content h3 {
  font-size: 32px;
  margin: 0;
  font-weight: 700;
  color: #1b1f3b;
}

.stat-content p {
  margin: 8px 0 4px;
  font-size: 18px;
  font-weight: 600;
  color: #1b1f3b;
}

.stat-content small {
  font-size: 16px;
  color: #777;
}

/* Features */


/* Business Transform */

.feature-card {
  background: #fff;
  border-radius: 16px;
  padding: 30px 20px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: transform 0.3s;
}

.certifications {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 20px;
}

.certifications img {
  width: 80px;
  height: auto;
}

.underline {
  width: 50px;
  height: 3px;
  background-color: #00b884;
  margin: 0 auto 40px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 cards on desktop */
  gap: 30px;
 
}

/* Tablets - 2 columns */
@media (max-width: 992px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
    padding: 0px 40px 60px 40px; /* Reduced padding */
  }
}

/* Mobiles - 1 column */
@media (max-width: 576px) {
  .features-grid {
    grid-template-columns: 1fr;
    padding: 0px 20px 50px 20px; /* Narrow padding */
  }

  .feature-card {
    padding: 20px 16px;
    text-align: center;
  }

  .icon-wrapper {
    margin-bottom: 10px;
  }
}

.feature-card {
  background: #fff;
  border-radius: 16px;
  padding: 30px 20px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: transform 0.3s;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
}

.feature-label {
  font-weight: 500;
  font-size: 18px;
  color: #1b1f3b;
}
.business-transform {
  text-align: center;
  padding: 10px 10px;
}

.business-transform h2 {
  font-size: 38px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #111827;
}

.business-transform p {
  margin: 16px 0 32px;
  color: #555;
 font-size: 18px;
}

.transform-grid {
  display: flex;
  justify-content: center;
  gap: 30px;
  padding: 10px 150px 10px 150px;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.transform-card {
  background: #fff;
  border-radius: 12px;
/* padding: 30px 50px 0px 50px; */
  width: 400px;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06); */
  /* transition: transform 0.3s ease; */
}

.transform-card:hover {
  transform: translateY(-5px);
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
}
.iconfiled{
  height: 30px;
  width: 25px;
}
.transform-card h3 {
  font-size: 28px;
  margin-bottom: 10px;
  font-weight: 600;
  color: #111827;
  
}

.transform-card p {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.5;
}

.business-transform  {
  background-color: #f3fafa;
  color: #fff;
  padding:  40px;
  border-radius: 8px;
  border: none;
  margin-top: 20px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.business-transform .btn-start:hover {
  background-color: #086cd1;
}
/* Tablet Screens */
@media (max-width: 992px) {
  .transform-grid {
    padding: 30px 60px;
    gap: 24px;
    justify-content: center;
  }

  .transform-card {
    width: 100%;
    max-width: 350px;
  }

  .business-transform h2 {
    font-size: 32px;
  }

  .business-transform p {
    font-size: 16px;
  }
}

/* Mobile Screens */
@media (max-width: 576px) {
  .transform-grid {
    padding: 20px;
    flex-direction: column;
    align-items: center;
  }

  .transform-card {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
    padding: 20px;
  }

  .icon-wrapper {
    width: 50px;
    height: 50px;
    margin-bottom: 16px;
  }

  .iconfiled {
    width: 24px;
    height: 24px;
  }

  .transform-card h3 {
    font-size: 20px;
  }

  .transform-card p {
    font-size: 14px;
  }

  .business-transform h2 {
    font-size: 24px;
    line-height: 1.4;
  }

  .business-transform p {
    font-size: 15px;
  }
}
/* --- Base Section Styles --- */
.ta-support-section {
  padding: 40px 20px;
  background-color: #2f863f; /* Very light slate, premium feel */
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  color: #ffffff; /* Deep slate instead of pure black */

}

.ta-support-container {
  max-width: 1100px;
  margin: 0 auto;
  
}

/* --- Header Styles --- */
.ta-support-header {
  text-align: center;
  margin-bottom: 50px;
}

.ta-support-badge {
  display: inline-block;
  padding: 6px 14px;
  background-color: #e0e7ff;
  color: #2b2b2b;
  font-size: 13px;
  font-weight: 700;
  border-radius: 20px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 16px;
}

.ta-support-header h2 {
  font-size: 40px;
  font-weight: 800;
  letter-spacing: -1px;
  margin-bottom: 16px;
  color: #f8f8f8;
}

.ta-support-subtext {
  font-size: 18px;
  color: #e2ebfc;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* --- Grid Layout --- */
.ta-support-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

/* --- Card Styles (The "Glass/Modern" Look) --- */
.ta-support-card {
  display: flex;
  align-items: flex-start;
  background: #ffffff;
  padding: 32px 24px;
  border-radius: 20px;
  border: 1px solid #f1f5f9;
  text-decoration: none;
  color: inherit;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}

.ta-support-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.05), 0 10px 10px -5px rgba(0, 0, 0, 0.02);
  border-color: #e2e8f0;
}

/* --- Icons --- */
.ta-card-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 20px;
  flex-shrink: 0;
}

/* Specific Icon Colors based on intent */
.phone-icon { background: #ecfdf5; color: #10b981; } /* Emerald */
.email-icon { background: #eff6ff; color: #3b82f6; } /* Blue */
.ticket-icon { background: #fffbeb; color: #f59e0b; } /* Amber */

/* --- Card Content --- */
.ta-card-content {
  flex-grow: 1;
}

.ta-card-content h3 {
  font-size: 14px;
  font-weight: 700;
  color: #64748b;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ta-card-content p {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px 0;
}

.ta-card-content small {
  font-size: 14px;
  color: #94a3b8;
  font-weight: 500;
}

/* --- Hover Arrow Animation --- */
.ta-card-arrow {
  color: #cbd5e1;
  font-size: 18px;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateX(-10px);
}

.ta-support-card:hover .ta-card-arrow {
  opacity: 1;
  transform: translateX(0);
  color: #4f46e5;
}

/* --- Primary Highlight Card (Optional styling for the main CTA) --- */
.ta-card-primary {
  border: 2px solid transparent;
}

.ta-card-primary:hover {
  border-color: #4f46e5; /* Highlights the "Raise a Ticket" card specifically */
}

/* --- Mobile Responsiveness --- */
@media (max-width: 768px) {
  .ta-support-header h2 {
    font-size: 32px;
  }
  .ta-support-card {
    padding: 24px 20px;
  }
  .ta-card-arrow {
    display: none; /* Hide arrow on mobile to save space */
  }
}
.terms-section {
  padding: 10px 10px;
  background: #f8fafc;
}

.terms-container {
  max-width: 1200px;
  margin: 0 auto;
    background: none!important
}

.terms-heading {
  font-size: 34px;
  font-weight: 700;
  margin-bottom: 30px;
  margin-top: 10px;
  color: #111827;
}

.terms-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.terms-item {
  background: #ffffff;
  padding: 15px 20px;
  border-radius: 16px;
  text-decoration: none;
  color: #065f46;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.terms-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
}

.terms-left {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 18px;
  font-weight: 500;
}

.terms-icon {
  background: #d1fae5;
  color: #065f46;
  padding: 10px;
  border-radius: 10px;
  font-size: 18px;
}

.terms-arrow {
  font-size: 24px;
  color: #065f46;
}`, "",{"version":3,"sources":["webpack://./src/pages/TAPAY.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;CACjB,sDAAsD;;EAErD,eAAe,EAAE,qCAAqC;AACxD;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;;EAEhD,oBAAoB;EACpB,qBAAqB;EACrB,UAAU;EACV,sCAAsC;;EAEtC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE,UAAU;EACV,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;AAGA,iCAAiC;AACjC;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6CAA6C;;AAE7C;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA;EACE,WAAW,GAAG,6BAA6B;EAC3C,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,0CAA0C;EAC1C,gBAAgB,GAAG,0BAA0B;EAC7C,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,6BAA6B;EACtD,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA,6BAA6B;AAC7B;EACE,qDAAqD;EACrD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;IACI,2DAA2D;EAC7D,yBAAyB;EACzB,iDAAiD;EACjD,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,aAAa;;;AAGb,uBAAuB;;AAEvB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,uBAAuB;EAC9D,SAAS;;AAEX;;AAEA,wBAAwB;AACxB;EACE;IACE,qCAAqC;IACrC,2BAA2B,EAAE,oBAAoB;EACnD;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,0BAA0B;IAC1B,2BAA2B,EAAE,mBAAmB;EAClD;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;CACZ,eAAe;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB,iCAAiC;EAC/B,YAAY;EACZ,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;AACA,mBAAmB;AACnB;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;AACA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,yBAAyB,EAAE,mCAAmC;EAC9D,0DAA0D;EAC1D,cAAc,EAAE,qCAAqC;;AAEvD;;AAEA;EACE,iBAAiB;EACjB,cAAc;;AAEhB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,iDAAiD;EACjD,kFAAkF;AACpF;;AAEA;EACE,2BAA2B;EAC3B,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,yCAAyC;AACzC,cAAc,mBAAmB,EAAE,cAAc,EAAE,EAAE,YAAY;AACjE,cAAc,mBAAmB,EAAE,cAAc,EAAE,EAAE,SAAS;AAC9D,eAAe,mBAAmB,EAAE,cAAc,EAAE,EAAE,UAAU;;AAEhE,yBAAyB;AACzB;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB,EAAE,sDAAsD;AAC/E;;AAEA,kCAAkC;AAClC;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa,EAAE,uCAAuC;EACxD;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;IACZ;AACJ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".landing-container {\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  background: #f9fafc;\r\n  color: #1b1f3b;\r\n}\r\n.payment-section {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 40px 9%;\r\n background: linear-gradient(135deg, #effdfc, #e3edf3 );\r\n\r\n  flex-wrap: wrap; /* allows stacking on small screens */\r\n}\r\n\r\n.payment-content {\r\n  flex: 1;\r\n  min-width: 300px;\r\n}\r\n\r\n.payment-image {\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  min-width: 300px;\r\n}\r\n\r\n.payment-image img {\r\n  max-width: 100%;\r\n  /* height: 400px; */\r\n  border-radius: 16px;\r\n  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1); */\r\n}\r\n.zoom-in-image {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 16px;\r\n  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1); */\r\n\r\n  /* Zoom-in on load */\r\n  transform: scale(0.8);\r\n  opacity: 0;\r\n  animation: zoomIn 1s ease-out forwards;\r\n\r\n  /* Optional: slight hover scale */\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.zoom-in-image:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n/* Keyframes */\r\n@keyframes zoomIn {\r\n  to {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n.slide-in-left {\r\n  opacity: 0;\r\n  transform: translateX(-50px);\r\n  animation: slideLeftFadeIn 1s ease-out forwards;\r\n}\r\n\r\n@keyframes slideLeftFadeIn {\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n\r\n/* Responsive - stack on mobile */\r\n@media (max-width: 992px) {\r\n  .payment-section {\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n\r\n  .payment-image {\r\n    justify-content: center;\r\n    margin-top: 30px;\r\n  }\r\n}\r\n\r\n\r\n.payment-content h2 {\r\n  font-size: 40px;\r\n  line-height: 1.3;\r\n  margin-bottom: 20px;\r\n  color: #1b1f3b;\r\n}\r\n\r\n.highlight-green {\r\n  color: #00b884;\r\n}\r\n\r\n.payment-content p {\r\n  font-size: 18px;\r\n  color: #555;\r\n  margin-bottom: 24px;\r\n  max-width: 500px;\r\n}\r\n\r\n.payment-buttons {\r\n  display: flex;\r\n  gap: 16px;\r\n  margin-bottom: 24px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.btn-explore,\r\n.btn-start {\r\n  padding: 12px 24px;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  border: none;\r\n  font-size: 14px;\r\n}\r\n\r\n.btn-explore {\r\n  background-color: #0b84ff;\r\n  color: #fff;\r\n}\r\n\r\n.btn-start {\r\n  background-color: #fff;\r\n  color: #00b884;\r\n  border: 2px solid #00b884;\r\n}\r\n\r\n.payment-features {\r\n  display: flex;\r\n  gap: 24px;\r\n  flex-wrap: wrap;\r\n  font-size: 16px;\r\n  margin-top: 16px;\r\n}\r\n\r\n.check-icon {\r\n  color: #00b884;\r\n  font-size: 18px;\r\n}\r\n\r\n.payment-card {\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  min-width: 500px;\r\n}\r\n\r\n.payment-card-balance {\r\n  background: #fff;\r\n  border-radius: 20px;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\r\n  padding: 24px;\r\n  min-width: 320px;\r\n  width: 100%;\r\n  max-width: 400px;\r\n}\r\n\r\n.balance-header {\r\n  background: linear-gradient(135deg, #0b84ff, #00b884);\r\n  border-radius: 16px;\r\n  padding: 20px;\r\n  color: #fff;\r\n}\r\n\r\n.balance-header p {\r\n  font-size: 18px;\r\n  margin: 0;\r\n}\r\n\r\n.balance-header h2 {\r\n  font-size: 32px;\r\n  margin: 8px 0;\r\n}\r\n\r\n.balance-header span {\r\n  font-size: 12px;\r\n  color: #e0f7fa;\r\n}\r\n\r\n.balance-transactions {\r\n  margin-top: 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.transaction {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background: #f9fbfd;\r\n  border-radius: 12px;\r\n  padding: 12px 16px;\r\n}\r\n\r\n.transaction-icon {\r\n  font-size: 20px;\r\n  margin-right: 12px;\r\n}\r\n\r\n.transaction-details {\r\n  flex-grow: 1;\r\n}\r\n\r\n.transaction-label {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #1b1f3b;\r\n}\r\n\r\n.transaction-time {\r\n  margin: 0;\r\n  font-size: 12px;\r\n  color: #555;\r\n}\r\n\r\n.transaction-amount {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n}\r\n\r\n.transaction-amount.income {\r\n  color: #00b884;\r\n}\r\n\r\n.transaction-icon.yellow {\r\n  color: #fbbf24;\r\n}\r\n\r\n.transaction-icon.purple {\r\n  color: #5a55e4;\r\n}\r\n\r\n/* ---------- Responsive Screens ---------- */\r\n\r\n@media (max-width: 992px) {\r\n  .payment-section {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    padding: 40px 5%;\r\n  }\r\n\r\n  .payment-content {\r\n    text-align: center;\r\n  }\r\n\r\n  .payment-card {\r\n    justify-content: center;\r\n    margin-top: 40px;\r\n    min-width: unset;\r\n    width: 100%;\r\n  }\r\n\r\n  .payment-card-balance {\r\n    max-width: 90%;\r\n  }\r\n\r\n  .payment-buttons {\r\n    justify-content: center;\r\n  }\r\n\r\n  .payment-features {\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .payment-content h2 {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .payment-content p {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .btn-explore,\r\n  .btn-start {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n\r\n  .payment-buttons {\r\n    flex-direction: column;\r\n    gap: 12px;\r\n  }\r\n\r\n  .payment-card-balance {\r\n    padding: 16px;\r\n  }\r\n\r\n  .transaction {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n  }\r\n\r\n  .transaction-amount {\r\n    align-self: flex-end;\r\n  }\r\n}\r\n\r\n.offerings {\r\n  text-align: center;\r\n  padding: 70px 10%;\r\n  background-color: #fff;\r\n}\r\n\r\n.offerings-heading {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  margin-bottom: 12px;\r\n  color: #1b1f3b;\r\n}\r\n\r\n.underline {\r\n  width: 50px;\r\n  height: 3px;\r\n  background-color: #00b884;\r\n  margin: 0 auto;\r\n  margin-top: 8px;\r\n}\r\n\r\n.offerings-grid {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 40px;\r\n  flex-wrap: wrap;\r\n  margin-top: 40px;\r\n}\r\n\r\n.offering-card {\r\n  background: #f9fbfd;\r\n  border-radius: 16px;\r\n  padding: 30px;\r\n  max-width: 400px;\r\n  text-align: left;\r\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\r\n  transition: transform 0.3s;\r\n}\r\n\r\n.offering-card:hover {\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.icon-wrapper {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 20px;\r\n\r\n}\r\n\r\n.icon {\r\n  color: #fff;  /* White color for the icon */\r\n  font-size: 24px;\r\n}\r\n\r\n\r\n.offering-card h3 {\r\n  margin-bottom: 12px;\r\n  color: #1b1f3b;\r\n  font-size: 20px;\r\n}\r\n\r\n.offering-card p {\r\n  color: #555;\r\n  font-size: 15px;\r\n  margin-bottom: 20px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.learn-more-btn {\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  border: 1px solid;\r\n  padding: 6px 12px;\r\n  border-radius: 6px;\r\n  text-decoration: none;\r\n  transition: background-color 0.3s, color 0.3s;\r\n}\r\n\r\n.learn-more-btn.green {\r\n  color: #00b884;\r\n  border-color: #00b884;\r\n}\r\n\r\n.learn-more-btn.green:hover {\r\n  background-color: #00b884;\r\n  color: #fff;\r\n}\r\n\r\n.learn-more-btn.purple {\r\n  color: #5a55e4;\r\n  border-color: #5a55e4;\r\n}\r\n\r\n.learn-more-btn.purple:hover {\r\n  background-color: #5a55e4;\r\n  color: #fff;\r\n}\r\n\r\n.arrow {\r\n  font-size: 16px;\r\n}\r\n.offering-card, .feature-card, .transform-card {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  flex: 1 1 250px;\r\n  /* box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08); */\r\n  text-align: center;\r\n  transition: transform 0.3s;\r\n}\r\n\r\n.offering-card:hover, .feature-card:hover, .transform-card:hover {\r\n  transform: translateY(-5px);\r\n}\r\n.offering-card {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  flex: 1 1 250px;\r\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\r\n  text-align: left;  /* Align content to left */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start; /* Align items to the start */\r\n  gap: 10px;\r\n  transition: transform 0.3s;\r\n}\r\n\r\n.offering-card svg {\r\n  font-size: 36px;\r\n  color: #0b84ff;\r\n}\r\n\r\n.offering-card h3 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  color: #1b1f3b;\r\n}\r\n\r\n.offering-card p {\r\n  font-size: 16px;\r\n  color: #555;\r\n  line-height: 1.6;\r\n}\r\n\r\n.offering-card h3, .feature-card, .transform-card h3 {\r\n  margin-top: 12px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n\r\n/* Stats Section New Design */\r\n.stats-container {\r\n  background: linear-gradient(135deg, #ebf2f9, #eafff8);\r\n  padding: 60px 10%;\r\n}\r\n\r\n.stats-grid {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 40px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.stat-item {\r\n    /* background: linear-gradient(135deg, #f5faff, #f9fbfd); */\r\n  /* border-radius: 16px; */\r\n  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); */\r\n  /* padding: 30px 20px; */\r\n  width: 220px;\r\n  text-align: center;\r\n  /* transition: transform 0.3s; */\r\n}\r\n\r\n.stat-item:hover {\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.icon-wrapper {\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 16px;\r\n}\r\n\r\n.stat-icon {\r\n  color: #fff;\r\n  font-size: 28px;\r\n}\r\n\r\n.stat-content h3 {\r\n  font-size: 32px;\r\n  margin: 0;\r\n  font-weight: 700;\r\n  color: #1b1f3b;\r\n}\r\n\r\n.stat-content p {\r\n  margin: 8px 0 4px;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #1b1f3b;\r\n}\r\n\r\n.stat-content small {\r\n  font-size: 16px;\r\n  color: #777;\r\n}\r\n\r\n/* Features */\r\n\r\n\r\n/* Business Transform */\r\n\r\n.feature-card {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  padding: 30px 20px;\r\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n  transition: transform 0.3s;\r\n}\r\n\r\n.certifications {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 16px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.certifications img {\r\n  width: 80px;\r\n  height: auto;\r\n}\r\n\r\n.underline {\r\n  width: 50px;\r\n  height: 3px;\r\n  background-color: #00b884;\r\n  margin: 0 auto 40px;\r\n}\r\n\r\n.features-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr); /* 4 cards on desktop */\r\n  gap: 30px;\r\n \r\n}\r\n\r\n/* Tablets - 2 columns */\r\n@media (max-width: 992px) {\r\n  .features-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    padding: 0px 40px 60px 40px; /* Reduced padding */\r\n  }\r\n}\r\n\r\n/* Mobiles - 1 column */\r\n@media (max-width: 576px) {\r\n  .features-grid {\r\n    grid-template-columns: 1fr;\r\n    padding: 0px 20px 50px 20px; /* Narrow padding */\r\n  }\r\n\r\n  .feature-card {\r\n    padding: 20px 16px;\r\n    text-align: center;\r\n  }\r\n\r\n  .icon-wrapper {\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n.feature-card {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  padding: 30px 20px;\r\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n  transition: transform 0.3s;\r\n}\r\n\r\n.feature-card:hover {\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.icon-wrapper {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 15px;\r\n}\r\n\r\n.feature-label {\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  color: #1b1f3b;\r\n}\r\n.business-transform {\r\n  text-align: center;\r\n  padding: 10px 10px;\r\n}\r\n\r\n.business-transform h2 {\r\n  font-size: 38px;\r\n  font-weight: 700;\r\n  margin-bottom: 10px;\r\n  color: #111827;\r\n}\r\n\r\n.business-transform p {\r\n  margin: 16px 0 32px;\r\n  color: #555;\r\n font-size: 18px;\r\n}\r\n\r\n.transform-grid {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 30px;\r\n  padding: 10px 150px 10px 150px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.transform-card {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n/* padding: 30px 50px 0px 50px; */\r\n  width: 400px;\r\n  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06); */\r\n  /* transition: transform 0.3s ease; */\r\n}\r\n\r\n.transform-card:hover {\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.icon-wrapper {\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 20%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 20px auto;\r\n}\r\n.iconfiled{\r\n  height: 30px;\r\n  width: 25px;\r\n}\r\n.transform-card h3 {\r\n  font-size: 28px;\r\n  margin-bottom: 10px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n  \r\n}\r\n\r\n.transform-card p {\r\n  font-size: 0.95rem;\r\n  color: #555;\r\n  line-height: 1.5;\r\n}\r\n\r\n.business-transform  {\r\n  background-color: #f3fafa;\r\n  color: #fff;\r\n  padding:  40px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  margin-top: 20px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.business-transform .btn-start:hover {\r\n  background-color: #086cd1;\r\n}\r\n/* Tablet Screens */\r\n@media (max-width: 992px) {\r\n  .transform-grid {\r\n    padding: 30px 60px;\r\n    gap: 24px;\r\n    justify-content: center;\r\n  }\r\n\r\n  .transform-card {\r\n    width: 100%;\r\n    max-width: 350px;\r\n  }\r\n\r\n  .business-transform h2 {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .business-transform p {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n/* Mobile Screens */\r\n@media (max-width: 576px) {\r\n  .transform-grid {\r\n    padding: 20px;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n  .transform-card {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    margin-bottom: 20px;\r\n    padding: 20px;\r\n  }\r\n\r\n  .icon-wrapper {\r\n    width: 50px;\r\n    height: 50px;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .iconfiled {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n\r\n  .transform-card h3 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .transform-card p {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .business-transform h2 {\r\n    font-size: 24px;\r\n    line-height: 1.4;\r\n  }\r\n\r\n  .business-transform p {\r\n    font-size: 15px;\r\n  }\r\n}\r\n/* --- Base Section Styles --- */\r\n.ta-support-section {\r\n  padding: 40px 20px;\r\n  background-color: #2f863f; /* Very light slate, premium feel */\r\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\r\n  color: #ffffff; /* Deep slate instead of pure black */\r\n\r\n}\r\n\r\n.ta-support-container {\r\n  max-width: 1100px;\r\n  margin: 0 auto;\r\n  \r\n}\r\n\r\n/* --- Header Styles --- */\r\n.ta-support-header {\r\n  text-align: center;\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.ta-support-badge {\r\n  display: inline-block;\r\n  padding: 6px 14px;\r\n  background-color: #e0e7ff;\r\n  color: #2b2b2b;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  border-radius: 20px;\r\n  letter-spacing: 0.5px;\r\n  text-transform: uppercase;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.ta-support-header h2 {\r\n  font-size: 40px;\r\n  font-weight: 800;\r\n  letter-spacing: -1px;\r\n  margin-bottom: 16px;\r\n  color: #f8f8f8;\r\n}\r\n\r\n.ta-support-subtext {\r\n  font-size: 18px;\r\n  color: #e2ebfc;\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* --- Grid Layout --- */\r\n.ta-support-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 24px;\r\n}\r\n\r\n/* --- Card Styles (The \"Glass/Modern\" Look) --- */\r\n.ta-support-card {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  background: #ffffff;\r\n  padding: 32px 24px;\r\n  border-radius: 20px;\r\n  border: 1px solid #f1f5f9;\r\n  text-decoration: none;\r\n  color: inherit;\r\n  position: relative;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\r\n}\r\n\r\n.ta-support-card:hover {\r\n  transform: translateY(-6px);\r\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.05), 0 10px 10px -5px rgba(0, 0, 0, 0.02);\r\n  border-color: #e2e8f0;\r\n}\r\n\r\n/* --- Icons --- */\r\n.ta-card-icon {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 20px;\r\n  margin-right: 20px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Specific Icon Colors based on intent */\r\n.phone-icon { background: #ecfdf5; color: #10b981; } /* Emerald */\r\n.email-icon { background: #eff6ff; color: #3b82f6; } /* Blue */\r\n.ticket-icon { background: #fffbeb; color: #f59e0b; } /* Amber */\r\n\r\n/* --- Card Content --- */\r\n.ta-card-content {\r\n  flex-grow: 1;\r\n}\r\n\r\n.ta-card-content h3 {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #64748b;\r\n  margin: 0 0 4px 0;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.ta-card-content p {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n  margin: 0 0 6px 0;\r\n}\r\n\r\n.ta-card-content small {\r\n  font-size: 14px;\r\n  color: #94a3b8;\r\n  font-weight: 500;\r\n}\r\n\r\n/* --- Hover Arrow Animation --- */\r\n.ta-card-arrow {\r\n  color: #cbd5e1;\r\n  font-size: 18px;\r\n  transition: all 0.3s ease;\r\n  opacity: 0;\r\n  transform: translateX(-10px);\r\n}\r\n\r\n.ta-support-card:hover .ta-card-arrow {\r\n  opacity: 1;\r\n  transform: translateX(0);\r\n  color: #4f46e5;\r\n}\r\n\r\n/* --- Primary Highlight Card (Optional styling for the main CTA) --- */\r\n.ta-card-primary {\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.ta-card-primary:hover {\r\n  border-color: #4f46e5; /* Highlights the \"Raise a Ticket\" card specifically */\r\n}\r\n\r\n/* --- Mobile Responsiveness --- */\r\n@media (max-width: 768px) {\r\n  .ta-support-header h2 {\r\n    font-size: 32px;\r\n  }\r\n  .ta-support-card {\r\n    padding: 24px 20px;\r\n  }\r\n  .ta-card-arrow {\r\n    display: none; /* Hide arrow on mobile to save space */\r\n  }\r\n}\r\n.terms-section {\r\n  padding: 10px 10px;\r\n  background: #f8fafc;\r\n}\r\n\r\n.terms-container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n    background: none!important\r\n}\r\n\r\n.terms-heading {\r\n  font-size: 34px;\r\n  font-weight: 700;\r\n  margin-bottom: 30px;\r\n  margin-top: 10px;\r\n  color: #111827;\r\n}\r\n\r\n.terms-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.terms-item {\r\n  background: #ffffff;\r\n  padding: 15px 20px;\r\n  border-radius: 16px;\r\n  text-decoration: none;\r\n  color: #065f46;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.terms-item:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.terms-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n}\r\n\r\n.terms-icon {\r\n  background: #d1fae5;\r\n  color: #065f46;\r\n  padding: 10px;\r\n  border-radius: 10px;\r\n  font-size: 18px;\r\n}\r\n\r\n.terms-arrow {\r\n  font-size: 24px;\r\n  color: #065f46;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
